export default __webpack_public_path__ + "static/ac2cfd93736bf45cb6fe458e39f32dda.png";